////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<template>
  <div>
    <span class="login-form-title">{{i18n.login.signup}}</span>
    <Form ref="loginData" :model="loginData" :rules="loginDataRules">
        <Form-item prop="phone">
            <Input-Phone v-model="loginData.phone" style="color:#707a80;" nextTabElId="email"></Input-Phone>
        </Form-item>
        <Form-item prop="email">
            <Input type="text" v-model="loginData.email" :placeholder="i18n.login.email" icon="ios-email" size="large" class="input-left-icon" id="email"></Input>
        </Form-item>
        <Form-item prop="name">
            <Input type="text" v-model="loginData.name" placeholder="Имя" icon="android-contact" size="large" class="input-left-icon"></Input>
        </Form-item>
        <Form-item prop="password">
            <Input type="password" v-model="loginData.password" :placeholder="i18n.login.password" icon="locked" size="large" class="input-left-icon"></Input>
        </Form-item>
        <Form-item prop="passwordTwice">
            <Input type="password" v-model="loginData.passwordTwice" :placeholder="i18n.login.passwordTwice" icon="locked" size="large" class="input-left-icon" @on-enter="submitOnClick()"></Input>
        </Form-item>
        <Form-item>
          <Button type="primary" size="large" class="login-form-button" long @click="submitOnClick()">{{i18n.login.signup}}</Button>
          <Row class="login-form-links-group">
            <Col span="12" class="login-form-link text-align-center2"><router-link to="/welcome">Вход</router-link></Col>
            <Col span="12" class="login-form-link text-align-center2"><router-link to="/">На главную</router-link></Col>
          </Row>
      </Form-item>
    </Form>
  </div>
</template>

////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<script>
import { mapGetters, mapMutations } from 'vuex'

import http from 'axios'

export default {
  name: 'SignUp',
  data () {
    return {
      loginData: {
        phone: '7',
        name: '',
        email: '',
        password: '',
        passwordTwice: '',
        invBy: 0
      },
      validatePassword: (rule, value, callback) => {
        if (value === '') {
          callback(new Error(this.i18n.login.validations.fieldCannotBeEmpty))
        } else {
          if (this.loginData.passwordTwice !== '') {
            this.$refs.loginData.validateField('passwordTwice')
          }
          callback()
        }
      },
      validatePasswordTwice: (rule, value, callback) => {
        if (value === '') {
          callback(new Error(this.i18n.login.validations.fieldCannotBeEmpty))
        } else if (value !== this.loginData.password) {
          callback(new Error(this.i18n.login.validations.passwordsNotEqual))
        } else {
          callback()
        }
      }
    }
  },
  computed: {
    ...mapGetters([
      'appSettings',
      'i18n'
    ]),
    loginDataRules: function () {
      return {
        phone: [
          { required: true, message: this.i18n.login.validations.fieldCannotBeEmpty, trigger: 'blur' },
          { type: 'string', min: 11, max: 11, message: 'Неверный номер телефона', trigger: 'blur' }
        ],
        email: [
          { required: true, message: this.i18n.login.validations.fieldCannotBeEmpty, trigger: 'blur' },
          { type: 'email', message: this.i18n.login.validations.fieldIsNotEmail, trigger: 'blur' },
          { type: 'string', min: 9, message: 'Слишком короткий почтовый адрес', trigger: 'blur' }
        ],
        name: [
          { required: true, message: this.i18n.login.validations.fieldCannotBeEmpty, trigger: 'blur' }
        ],
        password: [
          { validator: this.validatePassword, trigger: 'blur' }
        ],
        passwordTwice: [
          { validator: this.validatePasswordTwice, trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    ...mapMutations([
      'activeUserSet'
    ]),
    submitOnClick () {
      // this.$message(JSON.stringify(this.loginData, 2))

      this.$refs['loginData'].validate((valid) => {
        if (valid) {
          var thisRef = this
          if (this.appSettings.server.host == null) {
            thisRef.$message.error('Ошибка при попытке обратиться к серверу: Сервер не известен')
            return
          }
          var data = Object.assign({}, this.loginData)
          delete data.passwordTwice
          // записан туда в router только что и раньше что не важно, главное когда-то кто-то пришласил. по времени не ограничиваем
          var invBy = localStorage.getItem('invitedByUser')
          if (invBy != null) data.invBy = invBy
          else delete data.invBy
          http.post(this.appSettings.server.userSignup, data)
          .then(function (response) {
            // thisRef.$message.success('Вы зарегистрировались. Пожалуйста, войдите в приложение')
            // localStorage.setItem('BMSClientUser', thisRef.loginData.phone)
            // thisRef.loginData.password = '' // трем перед тем как уйти со страницы welcome. тогда при возврате на нее пароль не будет доступен
            // thisRef.loginData.passwordTwice = '' // трем перед тем как уйти со страницы welcome. тогда при возврате на нее пароль не будет доступен
            // thisRef.$router.push('/welcome')
            http.post(thisRef.appSettings.server.userLogin, {phone: thisRef.loginData.phone, password: thisRef.loginData.password})
            .then(function (response) {
              // localStorage.setItem('BMSClient2017ActiveUser', JSON.stringify(response.data))
              thisRef.activeUserSet(response.data)
              thisRef.loginData.password = '' // трем перед тем как уйти со страницы welcome. тогда при возврате на нее пароль не будет доступен
              thisRef.loginData.passwordTwice = '' // трем перед тем как уйти со страницы welcome. тогда при возврате на нее пароль не будет доступен

              var lastLandPage = localStorage.getItem('lastLandPage')
              if (lastLandPage == null) lastLandPage = '/'

              thisRef.$router.push(lastLandPage)
            })
            .catch(function (error) {
              if (error.response === null) {
                thisRef.$message.error('Ошибка при попытке обратиться к серверу: Сервер не доступен')
                thisRef.appStateServerConnectedSet(false)
                thisRef.$router.push('/serverisnotavailable')
              } else {
                if (error.response.status !== 400) {
                  thisRef.$message.error('Ошибка при попытке обратиться к серверу: ' + error.response.status + ', ' + JSON.stringify(error.response.data))
                } else {
                  thisRef.$message.error(error.response.data)
                }
              }
            })
          })
          .catch(function (error) {
            if (error.response === null) {
              thisRef.$message.error('Ошибка при попытке обратиться к серверу: Сервер не доступен')
              thisRef.appStateServerConnectedSet(false)
              thisRef.$router.push('/serverisnotavailable')
            } else {
              if (error.response.status !== 400) {
                thisRef.$message.error('Ошибка при попытке обратиться к серверу: ' + error.response.status + ', ' + JSON.stringify(error.response.data))
              } else {
                thisRef.$message.error(error.response.data)
              }
            }
          })
        } else {
          // this.$message.error('Поля заполненны не верно')
        }
      })
    }
  }
}
</script>

////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<style scoped>
</style>

////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////



// WEBPACK FOOTER //
// SignUp.vue?096cac12